
var backofficeUrl = 'https://cantonniers-bo-preprod.suez.fr/#'
var baseUrl = 'https://cantonniers-api-hml.suez.fr/cantonniers/api/v1'
var photoUrl = 'https://cantonniers-bo-preprod.suez.fr/#/photo/'

/*var backofficeUrl = 'https://cantonniers-bo-rec.suez.fr/#'
var baseUrl = 'https://cantonniers-api-rec.suez.fr/cantonniers/api/v1'
var photoUrl = 'https://cantonniers-bo-rec.suez.fr/#/photo/'*/

 /* var backofficeUrl = 'https://cantonniers-bo-dev.azurewebsites.net/#'
 var baseUrl = 'https://cantonniers-dev.azurewebsites.net/cantonniers/api/v1'
 var photoUrl = 'cantonniers-bo-dev.azurewebsites.net/#/photo/' */

export {baseUrl, backofficeUrl, photoUrl}



// WEBPACK FOOTER //
// ./src/config.js